import * as I18n from 'i18n-js'
// @ts-ignore
import * as ViewHelpers from '@waze/george/lib/view-helpers'

type TranslateFn = (key: string, options: {}) => string

export function querySelector<T extends Element>(el: Element, selector: string): T {
  const childEl: T | null = el.querySelector(selector)

  if (childEl == null) {
    throw new Error(`Cannot find selector ${selector}`)
  }

  return childEl
}

export function scopedTranslate(scope: string): TranslateFn {
  return (key: string, options: {}) => {
    const fullKey = key.charAt(0) === '.' ? scope + key : key
    return I18n.t(fullKey, options)
  }
}

export function linkify(translationKey: string, href: string, { newTab = true } = {}): string {
  let options: { [key: string]: string } = { href }
  if (newTab) {
    options = {
      target: '_blank',
      rel: 'noopener nofollow',
      ...options
    }
  }

  return ViewHelpers.tagify(I18n.t(translationKey), 'a', options)
}

export function tagify(text: string, tag: string, options: any = {}): string {
  return ViewHelpers.tagify(text, tag, options)
}

export function findParentWithClass(el: Element, className: string): Element | undefined {
  let parent = el.parentElement

  while (parent != null && parent !== document.body) {
    if (parent.classList.contains(className)) {
      return parent
    }

    parent = parent.parentElement
  }
}
